/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {UserDetailContract} from '../../../../api/ms-security/contracts/user-detail.contract';
import {UserDetailModel} from './user-detail.model';
import {UserEntityBaseMapper} from '../user-entity-base/user-entity-base.mapper';


export class UserDetailMapper {

    static fromUserDetailContractArray(input: readonly UserDetailContract[]): UserDetailModel[] {
        return input?.map(UserDetailMapper.fromUserDetailContract);
    }

    static fromUserDetailContract(input: UserDetailContract): UserDetailModel {
        let output: UserDetailModel;
        if (input != null) {
            output = {
                ...input,
                groups: input.groups != null ? UserEntityBaseMapper.fromUserEntityBaseContractArray([...input.groups]) : null
            };
        }
        return output;
    }
}
